<template>
  <div id="EventList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">人臉/文字任務</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right"></ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="event" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-2">
            <el-input
              v-model="CName"
              clearable
              placeholder="相薄名称"
            ></el-input>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table :data="EventList" :stripe="true" row-key="id" border>
                  <el-table-column
                    label="Id"
                    align="center"
                    prop="sgL_Coid"
                  ></el-table-column>
                  <el-table-column
                    label="相薄名稱"
                    align="center"
                    prop="sgL_CName"
                  ></el-table-column>
                  <el-table-column
                    label="相薄類型"
                    align="center"
                    prop="sgL_Type"
                  ></el-table-column>
                  <el-table-column
                    label="狀態"
                    align="center"
                    prop="sgL_ExecutingStatusF"
                  >
                  </el-table-column>
                  <el-table-column
                    label="開始時間"
                    align="center"
                    prop="sgL_StarTime"
                  >
                  </el-table-column>
                  <el-table-column
                    label="結束時間"
                    align="center"
                    prop="sgL_EndTime"
                  >
                  </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      prop="sgL_Coid"
                    >
                    <template slot-scope="scope">
                      <el-button type="primary" @click="UpdateExecutingStatus(scope.row.sgL_Id)" size="small" v-if="scope.row.sgL_ExecutingStatusF == '進行中'">
                        重新識別
                      </el-button>
                    </template>
                    </el-table-column>
                </el-table>
              </div>
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
import moment from "moment";
export default {
  data() {
    return {
      CName: "",
      EventList: [],
      //分页
      pageParams: {
        currentPage: 1,
        limit: 20,
        total: 0,
        pageshow: true,
      },
    };
  },
  components: {
    pagination,
  },
  created() {
    this.GetEventList();
  },
  watch: {
    CName: {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
  },
  methods: {
    async UpdateExecutingStatus(Id){
      const params = {
        Id
      };
      const { data : res } = await this.$api.albumApi.UpdateExecutingStatus(params);
      if (!res.success) {
        this.$message.error(res.error.message);
        return;
      }
      this.$message.success("操作成功");
      this.handleCurrentChange(1);
    },
    GetEventList() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        CName: this.CName,
      };
      this.$api.albumApi
        .AdminPhotoGalleryConfigAppSerivceGetExecuting(params)
        .then((res) => {
          if (res.data.success) {
            this.EventList = res.data.result.items;
            this.pageParams.total = res.data.result.totalCount;
          }
        });
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetEventList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetEventList();
    },
  },
  computed: {
    EventListModel() {
      return this.EventList;
    },
  },
};
</script>

<style scoped>
.ck:hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminAlbum/AdminImgDeal.vue